export const FETCH_KPI_CONFIG = {
  REQUEST: "FETCH_KPI_CONFIG_REQUEST",
  SUCCESS: "FETCH_KPI_CONFIG_SUCCESS",
  FAILURE: "FETCH_KPI_CONFIG_FAILURE",
};

export const LOAD_KPI_CONFIG = "LOAD_KPI_CONFIG";

export const RESET_KPI_CONFIG = "RESET_KPI_CONFIG";

export const LOAD_KPI_CONFIG_SERVICE_URL = "LOAD_KPI_CONFIG_SERVICE_URL";

export const SET_KPI_METRIC_GOAL = {
  REQUEST: "SET_KPI_METRIC_GOAL_REQUEST",
  SUCCESS: "SET_KPI_METRIC_GOAL_SUCCESS",
  FAILURE: "SET_KPI_METRIC_GOAL_FAILURE",
};

export const SET_KPI_METRIC_GOAL_ACTION = "SET_KPI_METRIC_GOAL_ACTION";

export interface SortBy {
  metricId: string;
  desc: boolean;
}

export interface DisplayMetric {
  metricId: string;
  label: string;
}

export interface ApiConfig {
  metricIds: string[];
  displayMetrics?: DisplayMetric[];
  dimensionIds?: string[];
  sortBy?: SortBy[];
  limit?: number;
}

export interface KpiMetric {
  id: string;
  title: string;
  metricType: "rate" | "number" | "seconds" | "currency" | "decimal";
  displayType: "basic" | "pie" | "tree" | "productList";
  polarity: "positive" | "negative";
  api: ApiConfig;
  goal?: number;
}

export interface KpiCategory {
  id: string;
  title: string;
  metrics: KpiMetric[];
}

export interface KpiConfig {
  goals?: string;
  categories: KpiCategory[];
}

export interface FetchKpiConfigPayload {
  storeId: string;
  language?: string;
}

export interface LoadKpiConfigAction {
  type: typeof LOAD_KPI_CONFIG;
  payload: FetchKpiConfigPayload;
}

export interface FetchKpiConfigRequestAction {
  type: typeof FETCH_KPI_CONFIG.REQUEST;
  payload: FetchKpiConfigPayload;
}

export interface FetchKpiConfigSuccessAction {
  type: typeof FETCH_KPI_CONFIG.SUCCESS;
  payload: KpiConfig;
}

export interface FetchKpiConfigFailureAction {
  type: typeof FETCH_KPI_CONFIG.FAILURE;
  payload: {
    error: string;
  };
}

export interface ResetKpiConfigAction {
  type: typeof RESET_KPI_CONFIG;
}

export interface SetKpiMetricGoalPayload {
  storeId: string;
  kpiMetricId: string;
  kpiMetricGoal: number;
  categoryId: string;
}

export interface SetKpiMetricGoalAction {
  type: typeof SET_KPI_METRIC_GOAL_ACTION;
  payload: SetKpiMetricGoalPayload;
}

export interface SetKpiMetricGoalRequestAction {
  type: typeof SET_KPI_METRIC_GOAL.REQUEST;
  payload: SetKpiMetricGoalPayload;
}

export interface SetKpiMetricGoalSuccessAction {
  type: typeof SET_KPI_METRIC_GOAL.SUCCESS;
  payload: SetKpiMetricGoalPayload;
}

export interface SetKpiMetricGoalFailureAction {
  type: typeof SET_KPI_METRIC_GOAL.FAILURE;
  payload: {
    error: string;
  };
}

export type KpiConfigActionTypes =
  | LoadKpiConfigAction
  | FetchKpiConfigRequestAction
  | FetchKpiConfigSuccessAction
  | FetchKpiConfigFailureAction
  | ResetKpiConfigAction
  | SetKpiMetricGoalAction
  | SetKpiMetricGoalRequestAction
  | SetKpiMetricGoalSuccessAction
  | SetKpiMetricGoalFailureAction;

export interface KpiConfigState {
  config: KpiConfig | null;
  isLoading: boolean;
  isLoaded: boolean;
  isSavingGoal: boolean;
  error: string | null;
}
